<div>
	<div class="modal-header">
		<h4 class="modal-title">Editer l'utilisateur {{username}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="userEditForm">
			<div class="form-group">
				<label for="name">Nom</label>
				<input #nameControl id="name" type="text" class="form-control" formControlName="nameControl" placeholder="Nom" ngbAutofocus (input)="nameControl.value = nameControl.value.toUpperCase()">
			</div>
            <div class="form-group">
				<label for="firstname">Prénom</label>
				<input #firstnameControl id="firstname" type="text" class="form-control" formControlName="firstnameControl" placeholder="Prénom" ngbAutofocus (input)="firstnameControl.value = firstnameControl.value.charAt(0).toUpperCase() + firstnameControl.value.slice(1)">
			</div>
			<div class="form-group">
				<label class="radio_label" for="role">Rôle</label>
				<select required #roleControl id="role" class="form-control" formControlName="roleControl" placeholder="Rôle">
					<option value="U">Utilisateur</option>
					<option value="I">Ingénieur</option>
					<option value="A">Administrateur</option>
				</select>
			</div>

			<label class="radio_label" for="company">Société</label>
			<div class="form-group">
				<div class="row">
					<div class="col-10">
						<select #companyControl id="companies" class="form-control" formControlName="companyControl">
							<option value="">Indéfinie</option>
							<option *ngFor="let company of companies" [ngValue]="company._id">{{company.name}}</option>
						</select>
					</div>
					<div class="col-2">
						<button matTooltipPosition="above" matTooltip="Ajouter une société" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doAddCompany()"><i class="material-icons md-24 icons">add</i></button>
					</div>
				</div>
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button matTooltip="Annuler" mat-raised-button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button matTooltip="Modifier l'utilisateur" mat-raised-button type="button" class="btn btn-primary" [disabled]="!enableAction || !userEditForm.valid" (click)="save()">{{buttonText}}</button>
	</div>
</div>
